/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { miscGetMiscTrackingQuery } from "../../funcs/miscGetMiscTrackingQuery.js";
import { GetMiscTrackingQueryRequest$zodSchema } from "../../models/getmisctrackingqueryop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetMiscTrackingQueryRequest$zodSchema,
};

export const tool$miscGetMiscTrackingQuery: ToolDefinition<typeof args> = {
  name: "misc-get-misc-tracking-query",
  description: `查询快递物流信息

买了东西想知道快递到哪儿了？这个接口帮你实时追踪物流状态。

> [!VIP]
> 本API目前处于**限时免费**阶段，我们鼓励开发者集成和测试。未来，它将转为付费API，为用户提供更稳定和强大的服务。

## 功能概述
提供一个快递单号，系统会自动识别快递公司并返回完整的物流轨迹信息。支持中通、圆通、韵达、申通、极兔、顺丰、京东、EMS、德邦等60+国内外主流快递公司。

## 使用须知
- **自动识别**：不知道是哪家快递？系统会根据单号规则自动识别快递公司（推荐使用）
- **手动指定**：如果已知快递公司，可以传递 \`carrier_code\` 参数，查询速度会更快
- **手机尾号验证**：部分快递公司需要验证收件人手机尾号才能查询详细物流，如果返回「暂无物流信息」，建议尝试传入 \`phone\` 参数
- **查询时效**：物流信息实时查询，响应时间通常在1-2秒内`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await miscGetMiscTrackingQuery(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
